import { render, staticRenderFns } from "./ChurchSelect.vue?vue&type=template&id=049ead10&scoped=true"
import script from "./ChurchSelect.vue?vue&type=script&lang=js"
export * from "./ChurchSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "049ead10",
  null
  
)

export default component.exports